import axios from 'axios';
import router from '../router/index';
import qs from 'qs'
import common from '../common/common'

// axios 配置
axios.defaults.timeout = 80000;
// axios.defaults.baseURL = 'https://www.lusionchina.com:448/dixcel';
// axios.defaults.baseURL = 'http://tz.s1.natapp.cc/dixcel'
axios.defaults.baseURL = common.publicUrl
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (localStorage.token) {  //判断token是否存在
      config.headers.Authorization = localStorage.token;  //将token设置成请求头
    }
    if(config.method === 'get'){
      //如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2
      config.paramsSerializer = function(params) {
        return qs.stringify(params, {arrayFormat: 'repeat'})
      }
    }
    if(config.method === 'post'){
      config.data = qs.stringify(
        config.data
      )
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  response => {
    // console.log(  response.data.status   )
    // console.log(  eval( "("+ response.data +")" )  )
    if ( response.data.status == 999 ) {
      // console.log( '过期了' )
      router.replace({name:'Login'});

    }
    return response;
  },
  error => {
    if(error.message.includes('timeout')){   // 判断请求异常信息中是否含有超时timeout字符串
      // console.log("错误回调", error);
      return Promise.reject(error);          // reject这个错误信息
    }
    return Promise.reject(error);
  }
);
export default axios;

